/** Official Worker version override is available only on the registered QA origin.
 * It never supplies Origin, identity, cookies or a CSRF value. Production ignores it. */
export function nativePreviewHeaders(location = typeof window === 'undefined' ? null : window.location): Record<string, string> {
  if (!location || location.origin !== 'https://analects-preview.bdfz.chat') return {};
  const version = new URLSearchParams(location.search).get('fuzi-version');
  return version && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(version)
    ? { 'Cloudflare-Workers-Version-Overrides': `fuzi="${version}"` } : {};
}
